export default __webpack_public_path__ + "static/media/extension_giftcard_gold_w2.b7dc2c31.svg";